import { useState } from 'react'
import { PhantomModal } from '../../components/PhantomModal'
import { phantomModalContents } from './chadata'

export const CharPhantoms = () => {
    const [showModal, setShowModal] = useState(false)

    const handleOpenModal = (category, index) => {
        setModalContent({
            category,
            index,
            content: phantomModalContents[index - 1].content,
        })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        // setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    const [modalContent, setModalContent] = useState({
        category: '',
        index: 0,
        content: [],
    })


    return (
        <>
            <div className='mx-auto my-20'>
                <div className='flex flex-wrap justify-center gap-8 mx-auto px-4'>
                    {phantomModalContents.map((char, i) => (
                        <div>
                            <span className={`relative  mx-auto`}>
                                <img
                                    onClick={() => {
                                        handleOpenModal('phantoms', i + 1)
                                    }}
                                    className={`hover:brightness-110 duration-300 mx-auto cursor-pointer hover:scale-105`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/phantoms/phantoms-char-thumb-${
                                        i + 1
                                    }.webp`}
                                    alt={char.name}
                                />
                            </span>
                        </div>
                    ))}
                </div>{' '}
              
            </div>{' '}
            <PhantomModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={13}
                phantomModalContents={phantomModalContents}
            />
        </>
    )
}
